import { render } from "./IDSessions.vue?vue&type=template&id=7a4079e3&ts=true"
import script from "./IDSessions.ts?vue&type=script&lang=ts&external"
export * from "./IDSessions.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__